export default __webpack_public_path__ + "static/media/hmd_background_l1.bd627334.jpg";